import { useCallback, useRef } from "react";

const usePositionSync = (
  syncFunction: (val: {
    nodes: { id: string; position_x: number; position_y: number }[];
  }) => void,
) => {
  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const pendingChangesRef = useRef(new Map<string, { x: number; y: number }>());

  return useCallback(
    (changes: { id: string; position: { x: number; y: number } }[]) => {
      changes.forEach(({ id, position }) => {
        pendingChangesRef.current.set(id, position);
      });
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        const nodesToSync = Array.from(pendingChangesRef.current);
        pendingChangesRef.current.clear();
        syncFunction({
          nodes: nodesToSync.map(([nodeId, position]) => ({
            id: nodeId,
            position_x: position.x,
            position_y: position.y,
          })),
        });
      }, 500);
    },
    [syncFunction],
  );
};

export default usePositionSync;
